import { getTranslation } from "@mivo/i18n";
import { CNPJ_VALIDATION_TRANSLATIONS as T } from "./clinicUiConstants";

const CNPJ_WEIGHTS1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function normalizeCnpjDigits(value: string): string {
    return value.replace(/\D/g, "").slice(0, 14);
}

export function formatCnpjDisplay(value: string): string {
    const d = normalizeCnpjDigits(value);
    if (d.length <= 2) {
return d;
}
    if (d.length <= 5) {
return `${d.slice(0, 2)}.${d.slice(2)}`;
}
    if (d.length <= 8) {
return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
}
    if (d.length <= 12) {
return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
}
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

function cnpjCheckDigit(digits: string, weights: number[]): number {
    const sum = weights.reduce((acc, w, i) => acc + Number(digits[i]) * w, 0);
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
}

export function isValidCnpj(value: string): boolean {
    const d = normalizeCnpjDigits(value);
    if (d.length !== 14) {
return false;
}
    if (/^(\d)\1+$/.test(d)) {
return false;
}
    const base = d.slice(0, 12);
    const d1 = cnpjCheckDigit(base, CNPJ_WEIGHTS1);
    const d2 = cnpjCheckDigit(base + d1, CNPJ_WEIGHTS2);
    return d === base + String(d1) + String(d2);
}

export function validateClinicTaxId(
    taxType: "CPF" | "CNPJ" | "",
    digits: string,
    isValidCpf: (v: string) => boolean,
): string | null {
    if (!taxType) {
return getTranslation(T.taxTypeRequired);
}
    if (!digits.trim()) {
return getTranslation(T.taxIdRequired);
}
    if (taxType === "CPF") {
        return isValidCpf(digits) ? null : getTranslation(T.cpfInvalid);
    }
    return isValidCnpj(digits) ? null : getTranslation(T.cnpjInvalid);
}
